import { NextOutgoingCallIdForACalledNumberAfterAGivenTimestamp } from 'src/models/phoneCall';

import { Callback } from 'src/util/query/models/Callback';

import { SetTheNextOutgoingCallIdForACalledNumberAfterAGivenTimestampPayload } from '../interfaces';

export class GetTheNextOutgoingCallIdForACalledNumberAfterAGivenTimestampQueryCallback extends Callback<NextOutgoingCallIdForACalledNumberAfterAGivenTimestamp> {
	public constructor(
		private readonly setNextOutgoingCallIdForACalledNumberAfterAGivenTimestamp: (
			payload: SetTheNextOutgoingCallIdForACalledNumberAfterAGivenTimestampPayload
		) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: NextOutgoingCallIdForACalledNumberAfterAGivenTimestamp): void => {
		if ('error' in successResponse && successResponse.error === 'NO_NEXT_OUTGOING_CALL_FOUND') {
			this.setNextOutgoingCallIdForACalledNumberAfterAGivenTimestamp({
				nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp: null,
			});
			return;
		}

		if (!('nextOutgoingCallId' in successResponse) || typeof successResponse.nextOutgoingCallId !== 'string') {
			this.setNextOutgoingCallIdForACalledNumberAfterAGivenTimestamp({
				nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp: null,
			});
			return;
		}

		this.setNextOutgoingCallIdForACalledNumberAfterAGivenTimestamp({
			nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp: parseInt(successResponse.nextOutgoingCallId, 10),
		});
	};
}
